import React, { useState, useEffect } from "react";
import IconDelete from "../../../assets/icons/trashWhiteIcon.svg";
import { useNavigate } from "react-router-dom";
import AddButton from "../../fragments/Buttons/AddButton";
import FilterInput from "../../fragments/Inputs/FilterInput";
import { formatearFecha } from "../../constructor/umas/Actividades/ActividadesUtils/ActividadesUtils";
import { coincideBusqueda } from "./gestorUtils";

const SubHeader = ({ data, setFilteredData }) => {
  const [inputvalue, setinputValue] = useState("");
  const navigate = useNavigate();

  // `coincideBusqueda` ignora acentos y mayúsculas: antes era un `includes`
  // crudo, así que "matematicas" no encontraba "Matemáticas" y ni siquiera
  // "examen" encontraba "Examen". Se agrega la fecha, que es por lo que más se
  // busca cuando el título no se recuerda.
  useEffect(() => {
    const filteredTests = data.filter(
      (el) =>
        coincideBusqueda(el?.titulo, inputvalue) ||
        coincideBusqueda(el?.descripcion, inputvalue) ||
        coincideBusqueda(formatearFecha(el?.fechaCreacion), inputvalue)
    );
    setFilteredData(filteredTests);
    // `data` a propósito fuera: el padre la recrea al recargar y volver a
    // filtrar aquí pisaría el listado recién cargado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputvalue]);

  const createNewTest = () => {
    navigate("/constructor/UmaConfiguration", { state: { esExamen: true } });
  };

  const openPapelera = () => {
    navigate("/papeleraExamenes", { state: { esExamen: true } });
  };

  // Mismo encabezado que el Gestor: `FilterInput` y `AddButton` compartidos, y
  // el espaciado lo da el `mx-3` del botón en lugar del padding del contenedor.
  return (
    <div className="flex items-center justify-center">
      <FilterInput
        value={inputvalue}
        onChange={(e) => setinputValue(e.target.value)}
        placeholder={"Buscar..."}
      />
      <AddButton
        text={"Crear examen"}
        styles="mx-3 inline-block"
        onClick={createNewTest}
      />
      <button
        className="btn-nimbus flex items-center mr-3"
        onClick={openPapelera}
      >
        <img src={IconDelete} alt="" />
        <div className="ml-2">Papelera</div>
      </button>
    </div>
  );
};

export default SubHeader;
